var mask = {};

mask.onlyLetters = (value) => {
    return value.replace(/[^a-zA-ZÀ-ÿ\s]/g, '');
};

mask.onlyNumbers = (value) => {
    return value.replace(/\D/g, '');
};

mask.maskPhone = (value) => {
    let cleaned = value.replace(/\D/g, '').substring(0, 11);

    if (cleaned.length <= 10) {
        var match = cleaned.match(/^(\d{0,2})(\d{0,4})(\d{0,4})$/);
    } else {
        var match = cleaned.match(/^(\d{0,2})(\d{0,5})(\d{0,4})$/);
    }

    if(match) {
        let part1 = match[1] ? `(${match[1]}` : '';
        let part2 = match[2] ? `) ${match[2]}` : '';
        let part3 = match[3] ? `-${match[3]}` : '';
        return `${part1}${part2}${part3}`.trim();
    }

    return value;
};

mask.maskCPF = (value) => {
    let cleaned = value.replace(/\D/g, '').substring(0, 11);

    // CPF mask
    let match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})$/);
    if(match) {
        let part1 = match[1] ? `${match[1]}` : '';
        let part2 = match[2] ? `.${match[2]}` : '';
        let part3 = match[3] ? `.${match[3]}` : '';
        let part4 = match[4] ? `-${match[4]}` : '';
        return `${part1}${part2}${part3}${part4}`.trim();
    }

    return value;
};

mask.maskCNPJ = (value) => {
    let cleaned = value.toUpperCase().replace(/[^0-9A-Z]/g, '').substring(0, 14);

    let match = cleaned.match(/^([0-9A-Z]{0,2})([0-9A-Z]{0,3})([0-9A-Z]{0,3})([0-9A-Z]{0,4})([0-9A-Z]{0,2})$/);
    if(match) {
        let part1 = match[1] ? `${match[1]}` : '';
        let part2 = match[2] ? `.${match[2]}` : '';
        let part3 = match[3] ? `.${match[3]}` : '';
        let part4 = match[4] ? `/${match[4]}` : '';
        let part5 = match[5] ? `-${match[5]}` : '';
        return `${part1}${part2}${part3}${part4}${part5}`.trim();
    }

    return value;
};

mask.maskDoc = (value) => {
    let cleaned = value.toUpperCase().replace(/[^0-9A-Z]/g, '').substring(0, 14);

    // CPF mask
    if (cleaned.length <= 11) {
        // CPF mask
        let match = cleaned.match(/^([0-9A-Z]{0,3})([0-9A-Z]{0,3})([0-9A-Z]{0,3})([0-9A-Z]{0,2})$/);

        if(match) {
            let part1 = match[1] ? `${match[1]}` : '';
            let part2 = match[2] ? `.${match[2]}` : '';
            let part3 = match[3] ? `.${match[3]}` : '';
            let part4 = match[4] ? `-${match[4]}` : '';
            return `${part1}${part2}${part3}${part4}`.trim();
        }
    }

    // CNPJ mask
    else return mask.maskCNPJ(value);
};

mask.maskCEP = (value) => {
    let cleaned = value.replace(/\D/g, '').substring(0, 8);

    let match = cleaned.match(/^(\d{0,5})(\d{0,3})$/);

    if(match) {
        let part1 = match[1] ? `${match[1]}` : '';
        let part2 = match[2] ? `-${match[2]}` : '';
        return `${part1}${part2}`.trim();
    }

    return value;
}

mask.maskHour = (value) => {
    let cleaned = value.replace(/\D/g, '').substring(0, 4);

    let match = cleaned.match(/^(\d{0,2})(\d{0,2})$/);

    if(match) {
        let part1 = match[1] ? `${match[1]}` : '';
        let part2 = match[2] ? `:${match[2]}` : '';
        return `${part1}${part2}`.trim();
    }

    return value;
}

export default mask;
